// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc } from '../components/BoundMaterialLeadTimeConfigFields.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CostCodeMaterialLeadTimesTabQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CostCodeFilter>;
}>;


export type CostCodeMaterialLeadTimesTabQuery = { __typename?: 'Query', costCodes: Array<{ __typename?: 'CostCode', id: string, materialLeadTimeConfig?: { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> } | null | undefined }> };

export type CostCodeMaterialLeadTimesTab_CostCodeFragment = { __typename?: 'CostCode', id: string, materialLeadTimeConfig?: { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> } | null | undefined };

export const CostCodeMaterialLeadTimesTab_CostCodeFragmentDoc = gql`
    fragment CostCodeMaterialLeadTimesTab_CostCode on CostCode {
  id
  materialLeadTimeConfig {
    ...BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfig
  }
}
    ${BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc}`;
export const CostCodeMaterialLeadTimesTabDocument = gql`
    query CostCodeMaterialLeadTimesTab($filter: CostCodeFilter) {
  costCodes(filter: $filter) {
    ...CostCodeMaterialLeadTimesTab_CostCode
  }
}
    ${CostCodeMaterialLeadTimesTab_CostCodeFragmentDoc}`;

/**
 * __useCostCodeMaterialLeadTimesTabQuery__
 *
 * To run a query within a React component, call `useCostCodeMaterialLeadTimesTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostCodeMaterialLeadTimesTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostCodeMaterialLeadTimesTabQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCostCodeMaterialLeadTimesTabQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CostCodeMaterialLeadTimesTabQuery, CostCodeMaterialLeadTimesTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CostCodeMaterialLeadTimesTabQuery, CostCodeMaterialLeadTimesTabQueryVariables>(CostCodeMaterialLeadTimesTabDocument, options);
      }
export function useCostCodeMaterialLeadTimesTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CostCodeMaterialLeadTimesTabQuery, CostCodeMaterialLeadTimesTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CostCodeMaterialLeadTimesTabQuery, CostCodeMaterialLeadTimesTabQueryVariables>(CostCodeMaterialLeadTimesTabDocument, options);
        }
export function useCostCodeMaterialLeadTimesTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CostCodeMaterialLeadTimesTabQuery, CostCodeMaterialLeadTimesTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CostCodeMaterialLeadTimesTabQuery, CostCodeMaterialLeadTimesTabQueryVariables>(CostCodeMaterialLeadTimesTabDocument, options);
        }
export type CostCodeMaterialLeadTimesTabQueryHookResult = ReturnType<typeof useCostCodeMaterialLeadTimesTabQuery>;
export type CostCodeMaterialLeadTimesTabLazyQueryHookResult = ReturnType<typeof useCostCodeMaterialLeadTimesTabLazyQuery>;
export type CostCodeMaterialLeadTimesTabSuspenseQueryHookResult = ReturnType<typeof useCostCodeMaterialLeadTimesTabSuspenseQuery>;
export type CostCodeMaterialLeadTimesTabQueryResult = Apollo.QueryResult<CostCodeMaterialLeadTimesTabQuery, CostCodeMaterialLeadTimesTabQueryVariables>;